import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { VisaLevelCreateDto, VisaLevelUpdateDto } from '../dtos/visaLevel/visaLevelDto';
@Injectable({
  providedIn: 'root'
})
export class VisaLevelService {
  private apiUrl = `${environment.apiUrl}/visaLevel`;

  constructor(private http: HttpClient) {}

  // Get list of Visa Levels
  getList(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}`);
  }

  //get by country Id
  getByCountryId(countryId: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${countryId}`);
  }

  // Create new Visa Level
  create(entity: VisaLevelCreateDto): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}`, entity);
  }

  // Update Visa Level
  update(id: number, entity: VisaLevelUpdateDto): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}`, entity);
  }

  // Delete Visa Level by Id
  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`);
  }
}
